import React, {useEffect, useState} from 'react';
import SecurityService from "../../../services/security-service";
import {Security} from "../../../models/security";
import Loading from "../../../components/loading/loading";
import styles from "./sa-authorizer-dashboard.module.scss";
import {Card, Col, Row, Table, Button} from "react-bootstrap";
import {toCurrency} from "../../../helpr/helper";
import ModalCustom from "../../../components/modal/modal";
import AuthorizeSecurityModalContent
  from "./components/modal-content-authorize-security/modal-content-authorize-security";
import RejectSecurityModalContent
  from "./components/modal-content-reject-security/modal-content-reject-security";

import {SECURITY_SUBMITTED} from "../../../helpr/constants";

const SaAuthorizerDashboard = () => {
  /*
    Modal properties and state
  */
  const [ action, setAction ] = useState();
  const [ style, setStyle] = useState(`${styles['authorize-security-modal']} ${styles['confirm-modal']}`);
  const [ show, setShow ] = useState(false);
  const [ mdlComponent, setMdlComponent ] = useState(false);

  /*
    Table properties and state
  */
  const securityService = new SecurityService();
  const headers = ["Name", "Agent", "Allocation", "Amount Ordered", "Date Submitted", ""];
  const [loading, setLoading] = useState(true);
  const [securityList, setSecurityList] = useState([]);

  //Load securities of entity for authorization
  useEffect(()=> {
    const initializeSecurityList = async () => {
      const result = await securityService.getListOfSecuritiesOnOffer(SECURITY_SUBMITTED);
      const securityList = result.map(s => new Security(s));
      setSecurityList(securityList);
      setLoading(false);
    }
    initializeSecurityList();
    // eslint-disable-next-line
  }, []);

  //Close modal method
  const onClose = () => setShow(false);

  //Show modal method and set selected security for authorization
  const showAuthorizeModal = (securityId, username) => {
    setMdlComponent(
      <AuthorizeSecurityModalContent
        data={{
          securityId: securityId,
          username: username
        }}
        updateTable={updateSecurityState}
        onClose={onClose}
        modalConfig={{setStyle}}/>
    );
    setAction('AUTHORIZATION OF SALES REPORT');
    setShow(true);
  }

  // Reject submission
  const showRejectModal = (securityId, username) => {
    setMdlComponent(
      <RejectSecurityModalContent
        data={{
          securityId: securityId,
          username: username
        }}
        updateTable={updateSecurityState}
        onClose={onClose}
        modalConfig={{setStyle}}/>
    )
    setAction('REJECTION OF SALESREPORT');
    setShow(true);
  }

  //Method for updating security status in state
  const updateSecurityState = (securityId, username) => {
    setSecurityList(prevState => prevState.map(s => {
        if(s.sortKey.split(':')[0] === username && s.securityId === securityId){
          return {
            ...s,
            securityStatus: '2'
          }
        }
        return s;
      })
    );
  }

  // Download salesreport file (consolidated orders)
  const downloadSalesreport = (securityId) => {
    async function service(securityId){
      const resp = await securityService.generateSalesReport(securityId);
      window.open(resp['s3FileUrl']);
    }
    service(securityId);
  }

  return loading ? <Loading /> : (
    <>
    <div className={styles['entity-security-list-table']}>
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <h1>Securities to Authorize</h1>
            </Card.Header>
            <Card.Body>
              <Table responsive>
                <thead>
                <tr>
                  {headers.map(
                    (header, index) => {
                      return <th key={index}>{header}</th>
                    }
                  )}
                </tr>
                </thead>
                <tbody>
                {securityList.map((data, index) => {
                    return data.securityStatus === '1' && (
                      <tr key={index}>
                        <td className={styles['security-name']}>
                          <img className={styles['title-icon']} src={`${process.env.REACT_APP_ASSETS_URL}${data.iconUrlSrc}`}/>
                          <span className={styles['security-name-span']}>{data.securityName}<br />
                            <span className={styles['issuer-span']}>{data.issuer}</span>
                          </span>
                        </td>
                        <td>{data.sellingAgentName}</td>
                        <td className={styles['price']}>{data.currency}{' '}{toCurrency(data.allocation)}</td>
                        <td className={styles['price']}>{data.currency}{' '}{toCurrency(data.amountOrdered)}</td>
                        <td className={styles['offer-date']}>{data.submittedDate}</td>
                        <td className={styles['actions']}>
                          <Button onClick={() => showAuthorizeModal(data.securityId, data.sortKey.split(':')[0])}>
                            Authorize
                          </Button>
                          <Button variant="danger" onClick={()=>showRejectModal(data.securityId, data.sortKey.split(':')[0])}>
                            Reject
                          </Button>
                          <Button onClick={()=>downloadSalesreport(data.securityId)}>
                            Download
                          </Button>
                        </td>
                      </tr>
                    )
                  })
                }
                </tbody>
              </Table>
              {securityList.length === 0
                ? <div className={styles['no-data']}>No submitted securities to authorize.</div>
                : ''
              }
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
    <ModalCustom
      show={show}
      title={action}
      onClose={onClose}
      component={mdlComponent}
      style={style} />
    </>
  )
}

export default SaAuthorizerDashboard;

